import ForgotPasswordPage from "./ForgotPasswordPage";

export default ForgotPasswordPage;

export * from "./ForgotPasswordPage";
